import React from 'react';

export function UserNameAndEmailColumnFormatter(cellContent) {

  return (
    <>
      <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
        {cellContent.profile.firstName} {cellContent.profile.lastName}
      </span>
      <div className="text-muted font-weight-bold">
        {cellContent.email}
      </div>
    </>
  );
}
